import { useQuery } from '@tanstack/react-query';
import { TattooChoices } from '@prisma/client';
import useUser from '../global/useUser';
import { getLocationOptions } from '../../services/global';

function useLocationOptions() {
  const { user } = useUser();

  const queryKey = ['locationOptions', user?.employee?.employeeId];

  const {
    data: locationOptions,
    isLoading,
    isFetching,
    isRefetching,
    refetch,
    isError,
  } = useQuery<TattooChoices[]>({
    queryKey,
    queryFn: getLocationOptions,
    enabled: !!user?.employee?.employeeId,
  });

  const sortedLocationOptions = locationOptions
    ?.slice()
    .sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase()));

  return {
    locationOptions: sortedLocationOptions,
    isLoading,
    isFetching,
    isRefetching,
    refetch,
    isError,
  };
}

export default useLocationOptions;
